import O1HD from "../gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ping extends cc.Component {

    @property(cc.Label)
    label: cc.Label = null;

    // LIFE-CYCLE CALLBACKS:

    onLoad() {
        O1HD.on('ping-time', this.onTimePing.bind(this),this);
    }

    start() {
        this.label.string = '...';
    }

    protected onTimePing(time: number) {
        this.label.string = `${Math.min(time, 999)}ms`;
    }

    // update (dt) {}
}
